import React, { PureComponent } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';
import {
  FormGroup,
  FormControl,
  Button,
  ControlLabel,
} from 'react-bootstrap/lib';

class ColorPicker extends PureComponent {
  constructor() {
    super();
    this.state = {
      displayPicker: false,
    };
  }

  onChange = (color) => {
    this.props.onChange({
      target: { name: this.props.name, value: color.hex },
    });
  };

  togglePicker = () =>
    this.setState({ displayPicker: !this.state.displayPicker });

  render() {
    const { formData, name, label, onChange } = this.props;

    // Picker styles
    const popover = {
      position: 'absolute',
      zIndex: '2',
      top: '35px',
    };
    const cover = {
      position: 'fixed',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
    };

    const value = get(formData, name);
    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <div className="widget-color-input">
          <FormControl
            name={name}
            type="text"
            onChange={onChange}
            value={value}
            pattern="#[A-Za-z0-9]{6}"
            required
          />
          <div
            className="widget-color-box"
            style={{ backgroundColor: value }}
          />
          <Button onClick={this.togglePicker}>Pick Color</Button>
          {this.state.displayPicker && (
            <div style={popover}>
              <div style={cover} onClick={this.togglePicker} />
              <ChromePicker
                color={value}
                onChange={this.onChange}
                disableAlpha
              />
            </div>
          )}
        </div>
      </FormGroup>
    );
  }
}

ColorPicker.propTypes = {
  formData: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
};

export default ColorPicker;
